<template>
    <div class="d-flex"
        @drag="preventEvent"
        @dragstart="preventEvent"
        @dragend="preventEvent"
        @dragover="preventEvent"
        @dragenter="preventEvent"
        @dragleave="preventEvent"
        @drop="preventEvent">
        <div class="image-container" v-if="!disabled && !filePath">
            <div class="image-select-wrapper d-flex flex-fill align-items-center justify-content-center">
                <div class="image-drag-drop-cover" v-if="isDragover" @drop="onDrop">
                    <div class="icon-drag-drop center">
                        <img :src="assetsPathTheme('/icons/drag-drop.svg')" />
                    </div>
                </div>
                <div v-else class="image-drag-wrapper" @dragover="onDragover">
                    <div class="icon-drag">
                        <!-- <img :src="assetsPathTheme('/icons/image.svg')" /> -->
                        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                            <path d="M12 3.5V20.5" stroke="#673AB7" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.5 12H3.5" stroke="#673AB7" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="image-input">
                        <label :for="idUpload" :class="{'cursor-pointer': !disabled}">
                        </label>
                    </div>
                    <div class="text-center" v-if="idUpload == 'image-upload-1' && showLimitMessage">
                        <p>
                            <span>Adicionar Images</span><br />
                            Pode adicionar até {{ maxFiles }} image{{ maxFiles == 1 ? '' : 's' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-container" v-if="filePath">
            <div class="image-preview-wrapper d-flex flex-fill align-items-center justify-content-center cursor-pointer"
                @click.prevent="">
                <div class="show-image lightbox"
                    :class="fileClass"
                    :style="{ 'background-image': isImage ? `url(${filePath})` : 'none' }">
                    <div class="file-wrapper" v-if="!isImage">
                        <div class="file-wrapper-content">
                            <div class="file-icon">
                                <i class="far fa-file-lines"></i>
                            </div>
                            <div class="file-name">
                                <p class="name">{{ fileName }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="image-overlay" :class="{'no-overlay': noOverlay}">
                        <div class="image-overlay-edit" @click.prevent="triggerFileUpdate" v-if="showEditButton">
                            <div class="icon-overlay text-center">
                                <i class="fas fa-pencil-alt"></i>
                            </div>
                        </div>
                        <div class="image-overlay-exclude" @click.prevent="onRemoveImage" v-if="showDeleteButton">
                            <div class="icon-overlay text-center">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </div>
                        <div class="image-overlay-details w-100" @click="onPreview">
                            <div class="icon-overlay text-center">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-list-container d-flex align-items-center" v-if="!!filePath && multiple && false">
            <div class="image-list-item" @click.prevent="">
                <div class="">
                    <img class="img-responsive" :src="filePath">
                </div>
            </div>
            <div class="image-list-item">
                <svg class="icon add-image-svg" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                    <path d="M511.5 227.5h-227V.5h-57v227H-.5v57h228v228h57v-228h227z"></path>
                </svg>
                <div class="input-add-image">
                    <label :for="idUpload" class="">
                    </label>
                </div>
            </div>
        </div>
        <div class="d-none" v-if="!disabled">
            <label :for="idUpload" ref="addImage" class=""></label>
            <input
                ref="uploadFile"
                :id="idUpload"
                name="files"
                type="file"
                class=""
                @change="uploadFieldChange"
                :multiple="multiple"
                :accept="accept"
                >
        </div>
    </div>
</template>
<script>
import GlobalMixin from '@/app/shared/mixins/global';
// :[captureKey]="captureMediaAttribute"

export default {
    name: 'FileContainer',
    mixins: [
        GlobalMixin
    ],
    props: {
        dragText: {
            type: String,
            default: 'Arrastar imagem'
        },
        browseText: {
            type: String,
            default: '(ou) Selecione'
        },
        primaryText: {
            type: String,
            default: 'Padrão'
        },
        markIsPrimaryText: {
            type: String,
            default: 'Definir como padrão'
        },
        popupText: {
            type: String,
            default: 'Esta imagem será exibida como padrão'
        },
        dropText: {
            type: String,
            default: 'Solte seus arquivos aqui ...'
        },
        accept: {
            type: String,
            default: 'image/gif,image/jpeg,image/png,image/bmp,image/jpg'
        },
        value: {
            default: () => {
                return []
            }
        },
        dataImages: {
            type: Array,
            default: () => {
                return []
            }
        },
        fileList: {
            type: Array,
            default: () => {
                return []
            }
        },
        fileClass: {
            type: String,
            default: 'background-cover'
        },
        multiple: {
            type: Boolean,
            default: true
        },
        showPrimary: {
            type: Boolean,
            default: true
        },
        maxFiles: {
            type: Number,
            default: 5
        },
        idUpload: {
            type: String,
            default: 'image-upload'
        },
        idEdit: {
            type: String,
            default: 'image-edit'
        },
        noOverlay: {
            type: Boolean,
            default: false,
        },
        targetFile: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showDeleteButton: {
            type: Boolean,
            default: true
        },
        showEditButton: {
            type: Boolean,
            default: true
        },
        showLimitMessage: {
            type: Boolean,
            default: false
        },
        fileIndex: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        capture: {
            type: String,
            default: '',
            validator: function (prop) {
                let valid = [
                    'capture', //the camera app
                    'user', // The user-facing camera and/or microphone should be used.
                    'environment', // The outward-facing camera and/or microphone should be used
                ];
                return !prop || prop && valid.includes(prop);
            }
        },
        filenameProperty: {
            type: String,
            default: 'name'
        },
        pathProperty: {
            type: String,
            default: 'path'
        },
        typeProperty: {
            type: String,
            default: 'type'
        },
    },
    data() {
        return {
            files: [],
            file: {},
            isDragover: false,
            update: false,
            captureMediaAttribute: '',
        }
    },
    computed: {
        // captureKey(){
        //     return !!this.captureMediaAttribute ? 'capture' : 'data-capture';
        // },
        fileType() {
            return (this.typeProperty && this.file && this.file.hasOwnProperty(this.typeProperty) ? this.file[this.typeProperty] : this.getImageTypeFromPath(this.filePath)) ?? 'image/jpeg';
        },
        fileName() {
            return this.filenameProperty && this.file && this.file.hasOwnProperty(this.filenameProperty) ? this.file[this.filenameProperty] : null;
        },
        filePath() {
            return this.file != {} ? this.file[this.pathProperty] : '';
        },
        fileObject() {
            return this.file?.file ?? null;
        },
        isImage() {
            return this.fileType.match(/image.*/);
        }
    },
    methods: {
        onPreview() {
            if(this.isImage) {
                this.$emit('preview', this.fileIndex);
            }else if(this.fileObject){
                let fileURL = URL.createObjectURL(this.fileObject);
                if(fileURL) {
                    window.open(fileURL, '_blank', );
                }
            }
        },
        copyValue (value) {
            if(this.targetFile[this.pathProperty]) {
                this.file = this.targetFile;
            } else {
                this.file = value;
            }
        },
        preventEvent(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onDrop(e) {
            this.isDragover = false;
            this.preventEvent(e);

            this.addFiles(e.dataTransfer.files);
        },
        onDragover() {
            this.isDragover = true;
        },
        uploadFieldChange(e) {
            this.addFiles(e.target.files || e.dataTransfer.files);
        },
        addFiles(files = []) {
            if (files.length == 0) {
                return false;
            }

            let amount = files.length + this.files.length;
             if(this.filePath) amount-=1
            if (amount > this.maxFiles) {
                this.$emit('limit-exceeded', amount);
                this.$root.$helper.messages.showToast('Limite de images excedido!', 'Erro', 'error');
                return false;
            }

            // process all File objects
            for (let i = 0, len = files.length; i < len; i++) {
                const file = files[i];
                if(this.filePath) {
                    this.$emit('updateImage', file, this.fileIndex);
                } else {
                    this.$emit('createImage', file);
                }
                if (!this.multiple) {
                    break;
                }
                // process image files under 300,000 bytes
                // if (file.type.indexOf("image") == 0 && file.size < 300000) {
                // ...
                // }
            }
            if (document.getElementById(this.idUpload)) {
                document.getElementById(this.idUpload).value = [];
            }
        },
        callFileEvent: function(capture = undefined) {
            this.captureMediaAttribute = capture === undefined ? this.capture : capture;
            this.$nextTick( ()=> {
                this.triggerFileUpdate();
            });
        },
        triggerFileUpdate: function() {
            if (!this.disabled && this.$refs.addImage) {
                this.update = true;
                this.$refs.addImage.click();
            }
        },
        onRemoveImage() {
            if(!this.disabled){
                this.file = {};
                this.$emit('removeFile', this.fileIndex);
            }
        },
        setCaptureAttribute: function() {
            let ref = this.$refs['uploadFile'];
            if(ref) {
                let value = this.captureMediaAttribute;
                let key = 'capture';
                if(value){
                    ref.setAttribute(key, value);
                }else{
                    ref.removeAttribute(key);
                }
            }
        },
        getFileTypeFromPath(path) {
            if(!path) return path;

            const regex = /(?:\.([^.]+))?$/; // Regular expression to capture file extension
            const extension = regex.exec(path)[1]; // Extract extension from PATH
            return extension ? extension.toLowerCase() : null;
        },
        getImageTypeFromPath(path) {
            const extension = this.getFileTypeFromPath(path);
            if(!extension) return null;

            if(['gif', 'jpe', 'jpg', 'jpeg', 'png', 'svg', 'bmp', 'webp'].includes(extension)) {
                return `image/${extension}`;
            }
            return null;
        }
    },
    mounted() {
        this.captureMediaAttribute = this.capture,
        document.body.addEventListener('dragleave', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            this.isDragover = false;
        })
    },
    created() {
        this.file = {};
        this.file = this.targetFile;
        this.files = [];
        this.files = this.fileList;
    },
    beforeMount() {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    watch: {
        captureMediaAttribute: {
            immediate: true,
            handler(newValue, oldValue){
                this.setCaptureAttribute();
            }
        },
        targetFile: function(newVal) {
            this.file = this.targetFile;
        },
        value (newValue) {
            // This watch works from the code side of the 2-way-binding:
            if(!this.targetFile[this.pathProperty]) {
                this.copyValue(newValue);
            }
        }
    },

}
</script>

<style scoped lang="scss">
@import '@styles/_theme.scss';

input[type="file"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
}

.image-container {
    flex: 1;
    position: relative;
    //height: 100%;

    >div {
        flex-grow: 3;
        width: 100%;
        height: 100%;
    }

    .image-select-wrapper {
        border: 2px dashed #ccc;
        background-color: #f6f6f6;
        border-radius: $occurrence-photo-border-radius-1;
        opacity: 0.4;

        .image-drag-drop-cover {
            width: 100%;
            height: 100%;

            .icon-drag-drop > img {
                height: 25px;
                width: 25px;
                @include sm {
                    height: 50px;
                    width: 50px;
                }
            }
        }

        .image-drag-wrapper {
            .icon-drag {
                margin: 0 auto;
                height: 25px;
                width: 25px;
                // @include sm {
                //     height: 50px;
                //     width: 50px;
                // }

                > img {
                    margin: 0 auto;
                    height: 25px;
                    width: 25px;
                    @include sm {
                        height: 50px;
                        width: 50px;
                    }
                }
            }

            div p {
                font-size: 1rem;
                > span {
                    color: $secondary-color;
                    font-size: 1.25rem;
                    font-weight: bold;
                }
            }

            .image-input {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                overflow: hidden;
                opacity: 0;

            }

            .image-input label {
                display: block;
                // cursor: pointer;
                width: 100%;
                height: 100%;
                transform: none;
                margin-bottom: 0;
            }
        }
    }

    .image-preview-wrapper {
        // cursor: pointer;

        .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            background: rgba(0, 0, 0, .7);
            opacity: 0;
            transition: opacity .3s ease-in-out 0s;
            border-radius: $occurrence-photo-border-radius-2;

            @media (min-width: 576px) {
                border-radius: $occurrence-photo-border-radius-1;
            }

            .image-overlay-details {
                position: absolute;
                z-index: 11;
                opacity: 0;
                transform: translate(0, -50%);
                top: 50%;
                text-align: center;
            }

            .image-overlay-exclude {
                position: absolute;
                z-index: 22;
                opacity: 0;
                transform: translate(0, -50%);
                text-align: center;
                top: 1rem;
                right: 5px;

                @include sm {
                    top: 0;
                    right: 0;
                    margin-top: calc(0px + 20px);
                    margin-right: calc(0px + 10px);
                }
            }

            .image-overlay-edit {
                position: absolute;
                z-index: 22;
                opacity: 0;
                transform: translate(0, -50%);
                text-align: center;
                top: 1rem;
                left: 5px;

                @include sm {
                    top: 0;
                    left: 0;
                    margin-top: calc(0px + 20px);
                    margin-left: calc(0px + 10px);
                }
            }

            .icon-overlay > i {
                color: #fff;

                // width: 20px;
                // height: 20px;
                font-size: 1rem;

                @include sm {
                    // max-width: 40px;
                    // max-height: 40px;
                    // width: 30%;
                    // height: 30%;
                    // font-size: 1.5rem;
                }
            }

            .image-overlay-details {
                .icon-overlay > i {
                    @include sm {
                        font-size: 1.5rem;
                    }
                }
            }

            .image-overlay-filename {
                position: absolute;
                z-index: 22;
                opacity: 0;
                text-align: center;
                top: auto;
                left: 0;
                right: 0;
                bottom: 0;
                margin: 1rem;
                text-align: center;
                font-size: 1rem;
            }

            &.no-overlay {
                cursor: default;
            }

            &:not(.no-overlay):hover {
                opacity: 1;

                .image-overlay-details {
                    opacity: 1;
                }

                .image-overlay-exclude {
                    opacity: 1;
                }

                .image-overlay-edit {
                    opacity: 1;
                }
            }
        }

        .show-image {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: $occurrence-photo-border-radius-2;
            background-repeat: no-repeat;
            background-position: center;
            &.background-auto {
                background-size: auto;
            }
            &.background-cover {
                background-size: cover;
            }
            &.background-contain {
                background-size: contain;
            }

            @media (min-width: 576px) {
                border-radius: $occurrence-photo-border-radius-1;
            }

            img {
                border-radius: $occurrence-photo-border-radius-2;
                max-height: 425px;

                @media (min-width: 576px) {
                    max-height: 100%;
                    border-radius: $occurrence-photo-border-radius-1;
                }
            }
        }

        .file-wrapper {
            position: absolute;
            transform: translate(0, -50%);
            top: 50%;
            left: 0;
            right: 0;

            .file-wrapper-content {
                display: flex;
                background: #f5f5f5;
                padding-right: .5rem;
                cursor: pointer;

                .file-icon {
                    background: #dfdfe1;
                    height: auto;
                    width: auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    padding: .7rem;
                }

                .file-name {
                    display: flex;
                    margin-left: 10px;
                    word-break: break-word;
                    align-items: center;

                    p {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

.center {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
</style>